// @ts-check

import { useState } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
import { BlockStack, Modal, Text } from "@shopify/polaris";
import { useQueryClient } from "@tanstack/react-query";

export const CreateSavedUtmSetExportModal = ({
  open,
  setOpen,
}) => {
  const shopify = useAppBridge();
  const queryClient = useQueryClient();

  const [createExportLoading, setCreateExportLoading] = useState(false);

  const createNewExport = async () => {
    setCreateExportLoading(true);

    return fetch("/api/saved-utm-set-exports", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        setOpen(false);
        shopify.toast.show("Export created");
        queryClient.invalidateQueries({ queryKey: ["utmSetExports"] });
      })
      .finally(() => {
        setCreateExportLoading(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Are you sure you want to create a new saved UTM set export?"
      primaryAction={{
        content: "Create export",
        onAction: createNewExport,
        loading: createExportLoading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => setOpen(false),
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="300">
          <Text as="p">This will create a CSV file that will contain all your saved UTM sets.</Text>

          <Text as="p">Your report will take a few minutes to generate, check back on this page later.</Text>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};
